if (!customElements.get('planted-bundle-price')) {
  // from 15.90 to 1590
  function floatPriceToInteger(floatPrice) {
    return Math.round(floatPrice * 100)
  }

  // return the price in integers, e.g. 1590 for $15.90
  function getBundleFinalPrice(bundle, totalPrice) {
    if (bundle.discount_type === 'percentage') {
      const percentage = parseInt(bundle.percentage_value, 10)
      const bundlePrice = totalPrice - (totalPrice / 100) * percentage
      return bundlePrice
    } else if (bundle.discount_type === 'fixed_amount') {
      return totalPrice - floatPriceToInteger(bundle.fixed_amount_value)
    } else if (bundle.discount_type === 'fixed_price') {
      return floatPriceToInteger(bundle.fixed_price_value)
    } else if (bundle.discount_type === 'products_discounts') {
      let discount = 0
      Object.values(bundle.products).forEach((product) => {
        discount += floatPriceToInteger(product.discount_amount)
      })
      return totalPrice - discount
    }
    return totalPrice
  }

  class PlantedBundlePrice extends HTMLElement {
    connectedCallback() {
      const moneyFormat = this.getAttribute('data-money-format')
      const bundleId = this.getAttribute('data-bundle-id')
      const originalPriceEls = this.querySelectorAll('[data-original-price]')
      const priceEls = this.querySelectorAll('[data-price]')
      const percentageEls = this.querySelectorAll('[data-product-discount]')
      const self = this

      // variants only needed for bundles
      const variantPriceList = JSON.parse(
        self.querySelector('script[data-variant-prices]').innerText
      )
      const variants = {}
      variantPriceList.forEach((variant) => {
        variants[variant.variantId] = variant
      })

      function initBundleUI() {
        const bundle = window.bndlr
          .getBundles()
          .find((bundle) => String(bundle.id) === String(bundleId))
        if (bundle) {
          let price = 0
          let available = true
          const variantIds = Object.keys(bundle.products)
          variantIds.forEach(function (id) {
            const bundleVariant = bundle.products[id]
            const variant = variants[id]
            if (!variant || !variant.available) {
              available = false
            }
            if (variant) {
              price += parseInt(variant.price, 10) * bundleVariant.quantity
            }
          })

          const formattedPrice = Shopify.formatMoney(price, moneyFormat)
          originalPriceEls.forEach((originalPriceEl) => {
            originalPriceEl.innerText = formattedPrice
            originalPriceEl.setAttribute('data-original-price', price)
          })

          const bundlePrice = getBundleFinalPrice(bundle, price)
          let percentage = 100 - Math.round((bundlePrice / price) * 100)
          // beautify the percentage:
          // - x1 or x9 rounded to y0
          // - x4 or x6 rounded to y5
          if (percentage % 10 === 9) {
            percentage += 1
          } else if (percentage % 10 === 1) {
            percentage -= 1
          } else if (percentage % 5 === 4) {
            percentage += 1
          } else if (percentage % 5 === 4) {
            percentage -= 1
          }

          const formattedBundlePrice = Shopify.formatMoney(
            bundlePrice,
            moneyFormat
          )
          priceEls.forEach((priceEl) => {
            priceEl.innerText = formattedBundlePrice
            priceEl.style.visibility = ''
            priceEl.setAttribute('data-price', bundlePrice)
          })

          percentageEls.forEach((percentageEl) => {
            percentageEl.innerText = `-${percentage}%`
            percentageEl.style.visibility = ''
          })
        }
      }
      if (window.bndlr) {
        initBundleUI()
      } else {
        document.addEventListener('bundler:loaded', initBundleUI.bind(this))
      }
    }
  }
  customElements.define('planted-bundle-price', PlantedBundlePrice)
}
